import springCenfApi from '../../services/springCenfApi'

export const getFaqs = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/faqs', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)